/**
 * Procedure Categories and Procedures for DM in Clinical Immunology and Rheumatology students
 * Extracted with strict evidence from official NMC PDF (Page 1, 4-5: "Psychomotor domain - perform independently")
 */
export const CLINICAL_IMMUNOLOGY_PROCEDURES = {
  "Diagnostic & Therapeutic Rheumatic Procedures": [
    "Diagnostic Synovial Fluid Aspiration (Joint Aspiration)",
    "Joint and Soft-Tissue Injections & Joint Lavage",
    "Nail Fold Capillaroscopy",
    "Salivary Gland Biopsy, Skin Biopsy & Muscle Biopsy",
    "Kidney Biopsy & Synovial Biopsy (Under Supervision)",
    "Musculoskeletal Ultrasound (MSK USG of Knee, Wrist & Joints)",
    "IVIG Therapy & Stem Cell Therapy Administration",
  ],
  "Immunological & Rheumatological Laboratory Procedures": [
    "Latex Fixation Test (RF & CRP)",
    "Indirect Immunofluorescence Assay (ANA / ANCA / anti-dsDNA on HEp-2 Cells)",
    "Nephelometry for Serum Proteins (C3, C4, CRP, RF, Ferritin, Immunoglobulins)",
    "ELISA Assay for Autoantibodies (anti-dsDNA, PR3, MPO, CCP2, Antiphospholipid)",
    "Immunoblot Assay for Specific Autoantigens",
    "Serum Electrophoresis & Myeloma Screening",
    "Synovial Fluid Microscopy (Cell Count & Polarizing Light Microscopy for Crystals)",
    "DNA Extraction & PCR for HLA-B27",
    "Immunoglobulin Subclass Estimation & Flowcytometry for Lymphocyte Subsets",
  ],
};

export const CLINICAL_IMMUNOLOGY_CATEGORIES = Object.keys(CLINICAL_IMMUNOLOGY_PROCEDURES);

export const isDMInClinicalImmunologyDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return (
    (d.includes("rheumatology") ||
    d.includes("clinical immunology") ||
    d.includes("immunology")) &&
    !d.includes("allergy")
  );
};
